export default "__VITE_PUBLIC_ASSET__984a49e6__"